<template>
  <div id="pageForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="page.label" label="Label" :required="true" />

      <v-select
        v-model="page.type"
        :items="page.relations.types"
        label="Type"
        chips
        deletable-chips
        item-value="value"
        item-text="name"
      />

      <v-select
        v-if="!isMenuGroup"
        v-model="page.parentId"
        :items="menuGroups"
        clearable
        label="Parent"
        :multiple="false"
        item-text="label"
        item-value="id"
        chips
        deletable-chips
      ></v-select>

      <v-text-field
        v-model="page.endpoint"
        label="Endpoint"
        :required="false"
        v-if="!isMenuGroup"
      />

      <v-select
        v-if="!isMenuGroup"
        v-model="page.endpointModule"
        :items="page.relations.endpointModule"
        label="Endpoint Module"
        chips
        deletable-chips
      />

      <v-text-field v-model="page.icon" label="Icon" :required="true" />
      <v-text-field
        v-model="page.default_param"
        label="Default Params"
        :required="true"
      />

      <v-select
        v-model="page.moduleId"
        :items="page.relations.moduleId"
        label="Module"
        :multiple="false"
        item-text="name"
        item-value="id"
        clearable
        chips
        deletable-chips
      ></v-select>
      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>
    
<script>
import { getPage } from "@/services/page";

import { getAllPages } from "@/services/page";

import { getAllModules } from "@/services/module";

import { mapActions } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      menuGroups: [],
      page: {
        relations: {
          endpointModule: [
            "accounts",
            "control",
            "forms",
            "form-admin",
            "reports",
            "compliance",
          ],
          moduleId: [],
          types: [
            { name: "Menu Group", value: "menu_group" },
            { name: "Menu Link", value: "link" },
            { name: "Seperator", value: "seperator " },
            { name: "Cross Module Link", value: "cross_module_link" },
          ],
        },
        label: "",
        endpoint: "",
        endpointModule: "",
        icon: "",
        default_param: "",
        parentId: {},
        moduleId: {},
        type: null,
      },
    };
  },
  created() {
    this.setInstace();
  },
  computed: {
    isMenuGroup() {
      return this.page.type == "menu_group";
    },
  },
  methods: {
    ...mapActions("page", ["createPage", "updatePage"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      if (this.id) {
        let page = this.page;
        delete page.relations;

        this.updatePage(page)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Page was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage("Error updating Page, please try again later");
          });
      } else {
        let page = this.page;
        delete page.relations;

        this.createPage(page)
          .then((response) => {
            console.log(response);
            this.addSuccessMessage("Page was created successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage("Error creating Page, please try again later");
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstace() {
      if (this.id) {
        this.page.id = this.id;
        getPage(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.page, property)
            ) {
              this.page[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {
      const params = {
        pageIndex: 0,
        pageSize: 100,
      };
      getAllPages(params).then((response) => {
        const allPages = response.data.content;
        this.menuGroups = allPages.filter((p) => !p.parentId);
      });

      const params_moduleId = {
        pageIndex: 1,
        pageSize: 100,
      };
      getAllModules(params_moduleId).then((response) => {
        this.page.relations.moduleId = response.data.content;
      });
    },
  },
  components: {},
};
</script>
